module.exports = __webpack_public_path__ + "img/pbo.e42448c2.png";